import { graphql } from "gatsby"
import { gql } from "@apollo/client"

export const query = graphql`
  fragment featuredCardContentBlockType on Craft_contentBlocks_FeaturedCard_BlockType {
    uid
    typeHandle
    style
    cardBGColor
    cardPicture {
      ...cardPictureAsset
    }
    cardContent
    videoUrl
    cardCTALink {
      target
      text
      type
      url
      element {
        ... on Craft_EntryInterface {
          uri
        }
      }
    }
  }
`

export const featuredCardContentBlockType = gql`
  fragment featuredCardContentBlockType on contentBlocks_FeaturedCard_BlockType {
    uid
    typeHandle
    style
    cardBGColor
    cardPicture {
      ...cardPictureAsset
    }
    cardContent
    videoUrl
    cardCTALink {
      target
      text
      type
      url
      element {
        uri
      }
    }
  }
`
